<template>
    {{ display }}
</template>

<script setup>
import { watch } from 'vue';
import { useVModel } from '@vueuse/core';

const props = defineProps({
    base: { required: false, default: 10, type: Number },
    decimals: { required: false, default: 2, type: Number },
    max: { required: true, type: Number },
    score: { required: true, type: Number },
    modelValue: { required: false, type: [Number, null] },
});

let emit = defineEmits(['update:modelValue']);

const display = useVModel(props, 'modelValue', emit);

function translateToBase(score, max, base) {
    if (Number.isNaN(score)) {
        return null;
    }
    if (score === '') {
        return null;
    }
    if (score === null) {
        return null;
    }
    return ((parseFloat(score) / max) * base).toFixed(props.decimals);
}

watch(
    [() => props.score, () => props.max],
    ([score, max]) => (display.value = translateToBase(score, max, props.base)),
    { immediate: true },
);
</script>
<script>
export default {
    name: 'ScoreOnBase',
};
</script>
